import React from 'react';
import styled, { css } from 'styled-components';
import { IconCircleFill } from '@/app/common/icons/libraryIcons';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { Text } from '@lmn/design-system';
import type { TextVariant } from '@lmn/design-system';

type SimpleAmenitiesProps = {
  amenities: { type: string; description: string; highlight: boolean }[];
  textVariant?: TextVariant;
} & React.HTMLAttributes<HTMLElement>;

const RoomSimpleAmenity = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 2px 0;
  margin-bottom: 2px;
`;

// REV: filter(({ type }) => type !== 'BEDROOMS_QUANTITY')
// OPX-2665 workaround to avoid showing bedrooms quantity, remove it when supply fixes the issue
export function RoomSimpleAmenities(props: SimpleAmenitiesProps) {
  const { amenities, textVariant = 'BodySmall', ...rest } = props;
  return (
    <ul
      css={css`
        @media ${customCss.breakpoints.sm} {
          column-count: 2;
        }
      `}
      {...rest}
    >
      {amenities
        .filter(({ type }) => type !== 'BEDROOMS_QUANTITY')
        .map((amenity, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <RoomSimpleAmenity key={`${index}-${amenity.type}`}>
            <IconCircleFill
              css={css`
                width: 16px;
                height: 4px;
                align-content: center;
                flex-shrink: 0;
              `}
            />
            <Text variant={textVariant}>{amenity.description}</Text>
          </RoomSimpleAmenity>
        ))}
    </ul>
  );
}
